import { render, staticRenderFns } from "./collect-customer-edit.vue?vue&type=template&id=0c26ebcf&scoped=true&"
import script from "./collect-customer-edit.vue?vue&type=script&lang=ts&"
export * from "./collect-customer-edit.vue?vue&type=script&lang=ts&"
import style0 from "./collect-customer-edit.vue?vue&type=style&index=0&id=0c26ebcf&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c26ebcf",
  null
  
)

export default component.exports